export default __webpack_public_path__ + "static/media/phillyfridges11_9_desktop.53661fa1.png";